import Swiper, { Autoplay } from 'swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { createApp, defineComponent, ref } from 'vue';
import EventVue from './opComponent/event.vue';
import FvSliderComponent from './opComponent/fvSlider.vue';
import Plyr from './opComponent/plyr';

const isSp = () => {
  if (window.innerWidth < 768) {
    return true;
  }
  return false;
};

const svSlider = () => {
  const svswiper = new Swiper('.opSv-slider', {
    autoplay: { delay: 5000 },
    speed: 1000,
    centeredSlides: true,
    loop: true,
    modules: [Autoplay],
    slideClass: 'opSv-slider_main',
    slidesPerView: 'auto',
    stopOnLastSlide: false,
    wrapperClass: 'opSv-slider_wrapper',
  });


};

const eventSort = () => {

  const FvSlider = defineComponent({
    components: { FvSliderComponent },
    template: `<FvSliderComponent />`,
  });
  const fvSlider = createApp(FvSlider);
  fvSlider.mount('#fvApp');

  const Events = defineComponent({
    components: { EventVue },
    template: `<EventVue ref="eventVue" :filterCategory="filterCategory" />`,
    setup() {
      const filterCategory = ref('');
      return { filterCategory };
    },
    mounted() {
      const targets = document.querySelectorAll('.opSv-slider_link');
      targets.forEach((target) => {
        target.addEventListener('click', () => {
          const category = target.getAttribute('data-category');
          this.$refs.eventVue.filterCategory = category;
        });
      });
      
    },
  });
  const app = createApp(Events);
  app.mount('#entry');

};

const movie = () => {
  // Plyrの設定
  const player = new Plyr('#videoPlayer', {
    // オプション設定
    autoplay: false, // 自動再生を無効にする
    hideControls: true, // コントロールバーを非表示にする
    muted: true, // 音声をミュートにする
  });

  // サムネイルをクリックしたら動画を再生する
  const thumbnail = document.getElementById('playButton');
  thumbnail.addEventListener('click', function () {
    player.play();
  });

  // 動画が再生されたときにサムネイル画像を非表示にする
  player.on('play', function () {
    thumbnail.style.display = 'none';
  });

  // 動画が再生を終了したときにサムネイル画像を再表示する
  // 動画が停止されたときにもサムネイル画像を表示する
  player.on('ended', function () {
    thumbnail.style.display = 'block';
  });
};

const schedule = () => {
  var tabBtns = document.querySelectorAll('.opSchedule-tabs_tab');
  for (var i = 0; i < tabBtns.length; i++) {
    tabBtns[i].addEventListener('click', function () {
      var tabId = this.getAttribute('data-tab');
      var tabContent = document.querySelectorAll('.opSchedule-content');
      for (var j = 0; j < tabContent.length; j++) {
        tabContent[j].classList.remove('active');
      }
      document.getElementById('tabsWrapper').classList.remove('tab1', 'tab2', 'tab3');
      document.getElementById('tabsWrapper').classList.add(tabId);
      document.getElementById(tabId).classList.add('active');
      var activeBtn = document.querySelector('.opSchedule-tabs_tab.active');
      if (activeBtn) {
        activeBtn.classList.remove('active');
      }
      this.classList.add('active');
    });
  }
};

const entryBtnAnimation = () => {
  // セクション1でのアニメーション
  const opMenuHeight = document.getElementById('opMenu').clientHeight;

  const ancherfv = gsap.timeline({
    paused: true,
    defaults: { duration: .6 },
  });
  ancherfv.to('#entryAnchor', {
    bottom: 0,
    scale: `${isSp() ? '.75' : '.6'}`,
    ease: 'cubic-bezier(.15,.53,.51,.99)',
  });
    
  ScrollTrigger.create({
    trigger: '#fv',
    start: 'top+=1 top',
    end: `+=${opMenuHeight}`,
    toggleActions: 'play none none reverse',
    animation: ancherfv,
  });

  // セクション2でのアニメーション
  const tl = gsap.timeline({
    paused: true,
  });
  tl.to('#entryAnchor', { opacity: 0, pointerEvents: 'none' });
  ScrollTrigger.create({
    trigger: '#events',
    start: 'top bottom',
    end: 'bottom top',
    toggleActions: 'play reverse play reverse',
    animation: tl,
    once: false,
  });

  gsap.to('.h-logo, .h-logo a', {
    opacity: 0,
    pointerEvents: 'none',
    scrollTrigger: {
      trigger: '#fv',
      start: 'top+=1 top',
      end: `+=${opMenuHeight}`,
      scrub: true,
    },
  });

}



eventSort();

window.addEventListener('DOMContentLoaded', () => {
  if (isSp()) {
    const fvSlider = document.getElementById('fvSlider');
    fvSlider.style.height = `calc(${window.innerHeight}px - ${54 / 3.75}vw)`;
    if (window.innerHeight < 560) {
      document.querySelector('.opFv-slider').classList.add('se');
    }
  }
  entryBtnAnimation();
  // fvSlider();
  svSlider();
  movie();
  schedule();

  // 古いヘッダー
  // SPナビ
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('sNtrigger')) {
      document.getElementById('headTop').classList.toggle('open');
    }
  });

  // SPナビ（メニュー：アコーディオン）
  document.addEventListener('click', function (event) {
    if (event.target.matches('#headerInner #headMid #navi span.t')) {
      event.target.classList.toggle('open');
      event.currentTarget.classList.toggle('open');
    }
  });
});



// ローディング
window.addEventListener('load', function () {
  setTimeout(function () {
    var splashLogo = document.getElementById('splashLoader');
    splashLogo.style.transition = 'slow';
    splashLogo.style.opacity = '0';

    setTimeout(function () {
      var splash = document.getElementById('splash');
      splash.style.transition = 'slow';
      splash.style.opacity = '0';

      setTimeout(function () {
        document.body.classList.add('appear');
      }, 100); // ローディングエリア（splashエリア）を1.5秒でフェードアウトする時間
    }, 100); // ロゴを1.2秒でフェードアウトする時間
  }, 0);
});
